import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
//
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "rc-slider/assets/index.css";
// STYLE
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import App from "./App";

let retryCount = 0;
const maxRetries = 10;

const checkRootElement = setInterval(() => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    clearInterval(checkRootElement);
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } else {
    retryCount++;
    if (retryCount >= maxRetries) {
      clearInterval(checkRootElement);
      throw new Error('Failed to find root element after maximum retries.');
    }
  }
}, 200);